import React, {useEffect, useRef, useState} from "react";
import {router, usePage} from "@inertiajs/react";
import {useEnhancedTranslation} from "laravel-inertia-backend";
import InertiaTable from "laravel-inertia-react-table";
import PillTableCell from "../Components/PillTableCell.jsx";
import CurrencyTableCell from "../Components/CurrencyTableCell.jsx";
import StatusTableCell from "../Components/StatusTableCell.jsx";
import {Col, Container, Form, Modal, Row, ToggleButtonGroup} from "react-bootstrap";
import {Button, ToggleButton, usePolling} from "laravel-inertia-backend";
import {mdiAccount, mdiCog, mdiEye, mdiFilterVariant, mdiLoading} from "@mdi/js";
import Icon from "@mdi/react";
import ChildView from "./Orders/ChildView.jsx";
import CommentInfoTableCell from "../Components/CommentInfoTableCell.jsx";
import ShopStatusTableCell from "../Components/ShopStatusTableCell.jsx";
import OrderPreview from "./Orders/OrderPreview.jsx";


export default function Orders(props) {
    const {t, getLocales} = useEnhancedTranslation();
    const {orders, extradata, col_definitions, visibleCols, userList, filters,user_roles,preview} = usePage().props;
    const [showModal, setShowModal] = useState(false);
    const [columns, setColumns] = useState(visibleCols);
    const tableRef = useRef(null);
    const orderTableRef = useRef(null);
    const outerElementRef = useRef(null);
    const [tableElementWidth,setTableElementWidth] = useState(null);
    const [previewWidthRatio,setPreviewWidthRatio] = useState(0.5);
    const previewWidthRatioRef = useRef(previewWidthRatio);
    const [userAssignMenuOpen,setUserAssignMenuOpen] = useState(null);

    useEffect(() => {
        previewWidthRatioRef.current = previewWidthRatio;
    }, [previewWidthRatio]);


    const {filterShop} = filters;
    const filterAssigned = filters.filterAssigned === '1';
    const filterNew = filters.filterNew === '1';
    const [showPreview, setShowPreview] = useState(false);
    const [selectedId,setSelectedId] = useState(null);

    usePolling('orders'); // Polling für Bestellungen aktivieren

    const handleRowClick = (order) => {
        if (!showPreview){
            return;
        }
        console.log("handleRowClick");
        console.log(order.id);
        setSelectedId(order.id);
    }

    const setFilterShop = (value) => {
        // Andernfalls die neue Auswahl setzen
        router.reload({data: {filter: {...filters, filterShop: value}}});

    }

    const setFilterAssigned = (value) => {
        router.reload({data: {filter: {...filters, filterAssigned: value ? 1 : 0}}});
    }

    const setFilterNew = (value) => {
        router.reload({data: {filter: {...filters, filterNew: value ? 1 : 0}}});
    }

    const handleChildRowContentRequest = (id) => {
        if (id !== -1) {
            router.reload({only: ['extradata', 'orders'], data: {extradata: id}});
        } else {
            const url = new URL(window.location.href);
            // 'extradata'-Parameter entfernen
            url.searchParams.delete('extradata');
            // URL aktualisieren
            window.history.replaceState({}, document.title, url.toString());
        }
    }

    const childLoadingPlaceholder = (
        <div className="spinner-container"
             style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px'}}>
            <Icon path={mdiLoading} size={2} spin={1}/>
        </div>
    );

    const onAssignedUserChange = (id, value) => {
        console.log("assigned user change");
        console.log(id);
        console.log(value);
        axios.get(`order/assign?id=${id}&assigned_user=${value}`).then(response => {
            router.reload();
        })
    }

    const onUnassignUser = (id, value) => {
        console.log("unassign user");
        console.log(id);
        console.log(value);
        axios.get(`order/unassign?id=${id}&assigned_user=${value}`).then(response => {
            router.reload();
        })

    }


    const handleColumnVisibilityChange = (id) => {
        setColumns(
            columns.map((col) =>
                col.id === id ? {...col, hidden: !col.hidden} : col
            )
        );
    };

    const applyColumnChanges = () => {
        const filteredColumns = columns.filter(column => column !== 'title');

        // Hier könntest du die neuen Einstellungen an den Server übergeben, falls nötig
        console.log('Gefilterte Spalten-Einstellungen:', filteredColumns);

        router.reload({data: {setVisibleCols: JSON.stringify(filteredColumns)}});


        setShowModal(false);
    };

    const onResizePreview = (width) => {
        //outerElementRef.current.style.width = width+"px";
        setPreviewWidthRatio( width / outerElementRef.current.getBoundingClientRect().width);
        setTableElementWidth(width);
    }


    const childRowContent = (<ChildView order={extradata}></ChildView>);

    const customToolbarButtons = (
        <>
            <Button
                disabled={user_roles.indexOf('admin') === -1}
                tooltip={t('Sichtbare Spalten einstellen')}
                    className={'ms-2'}
                    variant="secondary"
                    onClick={() => setShowModal(true)}
            >
                <Icon path={mdiCog} size={1}/>
            </Button>
            <ToggleButtonGroup className={'ms-2'} name="sortorder_switch" value={filterShop} type="radio"
                               onChange={setFilterShop}>
                <ToggleButton id={"filter_b2c"} variant="outline-secondary" value={"b2c"}>{t('B2C')}</ToggleButton>
                <ToggleButton id={"filter_all"} variant="outline-secondary" value={"all"}>{t('alle')}</ToggleButton>
                <ToggleButton id={"filter_b2b"} variant="outline-secondary" value={"b2b"}>{t('B2B')}</ToggleButton>
            </ToggleButtonGroup>
            <ToggleButton className={"ms-2"} type="checkbox" id={"filter_new"} tooltip={t('nur neue')}
                          variant="outline-secondary"
                          checked={!!filterNew} onChange={(e) => setFilterNew(e.currentTarget.checked)}
                          value={"1"}>{t('only new')}</ToggleButton>
            <ToggleButton className={"ms-2"} type="checkbox" id={"filter_assigned"} tooltip={t('nur mir zugewiesen')}
                          variant="outline-secondary"
                          checked={!!filterAssigned} onChange={(e) => setFilterAssigned(e.currentTarget.checked)}
                          value={"1"}><Icon path={mdiAccount} size={1}/></ToggleButton>
            <ToggleButton className={"ms-2"} type="checkbox" id={"preview_button"} tooltip={t('Vorschau anzeigen')}
                          variant="outline-secondary"
                          checked={!!showPreview} onChange={(e) => {setShowPreview(e.currentTarget.checked); setSelectedId(orders.data[0].id); }}
                          value={"1"}><Icon path={mdiEye} size={1}/></ToggleButton>

        </>
    );

    const getColVisiblitiy = (id) => {
        const column = columns.find(col => col.id === id);
        return column ? column.hidden : false;
    };

    const customRowClass = (row) => {
        let rowClass = [];
        if (row.assigned_user_ids === null) {
            rowClass = ['user-unassigned'];
        }

        if (row.status === 0) {
            rowClass.push('order-error');
        } else if (row.manual_state === 1) {
            rowClass.push('order-closed');
        }

        if (row.is_order_withdrawn) {
            rowClass.push('order-withdrawn');
        }

        return rowClass;
    }

    const selectedIdRef = useRef(selectedId);

    useEffect(() => {
        selectedIdRef.current = selectedId;
    }, [selectedId]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "ArrowUp") {
                event.preventDefault();
                const currentIndex = orders.data.findIndex(item => item.id === selectedIdRef.current);
                if (currentIndex > 0) {
                    const newSelectedId = orders.data[currentIndex - 1].id;
                    console.log("Navigating up, new ID:", newSelectedId);
                    setSelectedId(newSelectedId);
                }
            }
            if (event.key === "ArrowDown") {
                event.preventDefault();
                const currentIndex = orders.data.findIndex(item => item.id === selectedIdRef.current);
                if (currentIndex < orders.data.length - 1) {
                    const newSelectedId = orders.data[currentIndex + 1].id;
                    console.log("Navigating down, new ID:", newSelectedId);
                    setSelectedId(newSelectedId);
                }
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [orders]);

    useEffect(() => {
        console.log("selectedId changed");
        if (selectedId && tableRef.current) {
            if (showPreview) {
                handlePreviewContentRequest(selectedId);
            }
            // Suche nach der Tabellenzeile, die zu der selectedId passt
            const row = tableRef.current.querySelector(`[data-id="${orders.data.findIndex(item => item.id === selectedId)}"]`);
            console.log('Scrolling to row:');
            if (row) {

                row.scrollIntoView({
                    behavior: "smooth", // sorgt für sanftes Scrollen
                    block: "nearest" // Zeile wird zentriert
                });
            }
        }
    }, [selectedId]);


    const handlePreviewContentRequest = (id) => {
        if (id !== -1) {
            router.reload({only: ['preview'], data: {preview: id}});
        } else {
            const url = new URL(window.location.href);
            // 'preview'-Parameter entfernen
            url.searchParams.delete('preview');
            // URL aktualisieren
            window.history.replaceState({}, document.title, url.toString());
        }
    }

    useEffect(() => {
        // Funktion zur Berechnung der Breite
        const calculateWidth = () => {
            if (outerElementRef.current) {
                const width =
                    outerElementRef.current.getBoundingClientRect().width *
                    previewWidthRatioRef.current; // Greife auf "aktuelle" Version zu
                setTableElementWidth(width);
            }
        };

        calculateWidth(); // Initiale Brechnung der Breite

        // Event-Listener hinzufügen, um die Breite beim Fensterrandern zu aktualisieren
        window.addEventListener("resize", calculateWidth);

        return () => {
            window.removeEventListener("resize", calculateWidth); // Listener beim Unmount entfernen
        };
    }, []);

    return (<>
            <div className="h-100 d-flex flex-row" ref={outerElementRef}>
                <div ref={orderTableRef} style={{width: showPreview ? tableElementWidth+"px" : "100%"}}>
                    <InertiaTable key={"orders-table"}
                        innerRef={tableRef} // Referenz für das Tabellen-Element
                        hiddenCols={columns.filter(col => col.hidden).map(col => col.id)}
                        customRowClass={customRowClass}
                        customCellRendererMap={{
                            'shop_order_id': CommentInfoTableCell,
                            'shop_status_display': ShopStatusTableCell,
                            'assigned_users':
                                ({id, className, children, rowData}) => (
                                    <PillTableCell id={id} rowData={rowData} className={className} children={children}
                                                   selectList={userList}
                                                   menuOpen={userAssignMenuOpen===rowData.id} onMenuChange={(value) => {setUserAssignMenuOpen(value ? rowData.id : null);}}
                                                   onUnSelect={(unselectedValue) => onUnassignUser(rowData.id, unselectedValue.id)}
                                                   onSelect={(selectedValue) => onAssignedUserChange(rowData.id, selectedValue)}/>),
                            'total': CurrencyTableCell,
                            'total_incl_tax': CurrencyTableCell
                        }}
                        data={orders} options={{striped: true, childRows: true, selectable: showPreview}}
                        title={t('Orders')}
                        selectedIds={[selectedId]}
                        onRowClick={showPreview ? handleRowClick : undefined}
                        childRowContent={childRowContent}
                        customToolbarButtons={customToolbarButtons}
                        onChildRowContent={handleChildRowContentRequest}
                        childLoadingPlaceholder={childLoadingPlaceholder}
                    />
                </div>
                <OrderPreview show={showPreview} order={preview} onClose={() => setShowPreview(false)} resizeRef={orderTableRef} onResize={onResizePreview}/>
            </div>

            {/* Modal zum Einstellen der sichtbaren Spalten */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Sichtbare Spalten einstellen</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form className="ms-2">
                        {col_definitions.map((colDef) => {
                                if (colDef.hidden) {
                                    return null;
                                }
                                return (<Form.Check
                                        type="switch"
                                        id={`column-${colDef.id}`}
                                        key={colDef.id}
                                        label={t(colDef.title)}
                                        checked={!getColVisiblitiy(colDef.id)}
                                        onChange={() => handleColumnVisibilityChange(colDef.id)}
                                    />
                                )
                            }
                        )}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Abbrechen
                    </Button>
                    <Button variant="primary" onClick={applyColumnChanges}>
                        Übernehmen
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
